<div class="sticky-top">
	<app-navbar [showReservationSearch]="false" [title]="title()">
		<div class="d-flex flex-row gap-3">
			<ng-content></ng-content>

			<div class="horizontal-separator"></div>
			<button
				[disabled]="buttonsDisabled()"
				(click)="openTransportCopyModal()"
				class="btn btn-warning text-small"
			>
				<i class="fa fa-copy"></i> Kopiuj
			</button>

			@if (this.transportsToLinkNames().length) {
				<button [disabled]="buttonsDisabled()" (click)="unlinkTransport()" class="btn btn-warning text-small">
					<i class="fas fa-unlink"></i> Rozłącz
				</button>
			}

			<div class="horizontal-separator"></div>
			<button (click)="openMailDialog()" [disabled]="buttonsDisabled()" class="btn btn-danger text-small">
				<i class="fa fa-envelope"></i> Mail
			</button>
			<div class="horizontal-separator"></div>
			<div class="d-flex gap-3">
				<button
					[disabled]="buttonsDisabled() || module() === TransportModule.MAP"
					(click)="switchModule(TransportModule.MAP)"
					class="btn btn-danger text-small"
				>
					<i class="fa fa-map"></i> Mapa
				</button>
				<button
					[disabled]="buttonsDisabled() || module() === TransportModule.TIMETABLE"
					(click)="switchModule(TransportModule.TIMETABLE)"
					class="btn btn-danger text-small"
				>
					<i class="fa fa-calendar-days"></i> Rozkład
				</button>
				<button
					[disabled]="buttonsDisabled() || module() === TransportModule.LIST"
					(click)="switchModule(TransportModule.LIST)"
					class="btn btn-danger text-small"
				>
					<i class="fa fa-id-card"></i> Listy
				</button>
				<button
					[disabled]="buttonsDisabled() || module() === TransportModule.COACH_LIST"
					(click)="switchModule(TransportModule.COACH_LIST)"
					class="btn btn-danger text-small"
				>
					<i class="fas fa-bus"></i> Listy autokarowe
				</button>

				<div class="horizontal-separator"></div>

				<input
					type="text"
					placeholder="Nazwa transportu"
					[formControl]="transportNameControl"
					(click)="updateName()"
					class="rounded-2 text-small"
				/>
				<button [disabled]="disableSaveButton()" class="btn btn-success text-small" (click)="saveTransport()">
					<i class="fa fa-check"></i> Zapisz
				</button>
				<button [disabled]="disableSaveButton()" class="btn btn-danger text-small" (click)="removeTransport()">
					<i class="fa-solid fa-xmark"></i> Usuń
				</button>
				@if (module() === TransportModule.COACH_LIST) {
					<button
						(click)="resetCoachList()"
						[disabled]="buttonsDisabled()"
						class="btn btn-warning text-small"
					>
						<i class="fa-solid fa-repeat"></i> Resetuj siedzenia
					</button>

					@if (side() === TransportSide.RETURN) {
						<button
							(click)="copyCoachList()"
							[disabled]="buttonsDisabled()"
							class="btn btn-warning text-small"
						>
							<i class="fa-solid fa-copy"></i> Kopiuj z wyjazdu
						</button>
					}

					@if (coachListUrl()) {
						<a [href]="coachListUrl()" target="_blank"
							><button class="btn btn-light text-small">
								<i class="fas fa-file-excel me-2"></i>Spreadsheet
							</button></a
						>
					}
				}
			</div>
		</div>
	</app-navbar>
	@if (this.transportsToLinkNames().length) {
		<div class="alert alert-danger p-2 text-small d-flex flex-row gap-2 mb-0">
			Uwaga! Jesteś w trybie łączenia transportów.
			@for (name of this.transportsToLinkNames(); track name) {
				<span class="badge bg-primary">{{ name }}</span>
			}
		</div>
	}
</div>
